import { GPX_FEATURES, GPXFeature } from '@rsos/gainsight';
import useIsVT911Enabled from '../../../../../hooks/useIsVT911Enabled';
import {
  trackStartTF911Click,
  trackTogglingTF911Accordion,
} from '../../textFrom911Trackings';
import usePreconfiguredMessages from '../usePreconfiguredMessages';
import TF911StartChatBase from './TF911StartChatBase';
import TF911StartChatNoAccordion from './TF911StartChatNoAccordion';

interface TF911StartChatAccordionProps {
  isCreatingConversation: boolean;
  isForOverview?: boolean;
  isUniteEventPaneEnabled: boolean;
  onClickShowAccordion: () => void;
  onStartConversation: (message?: string) => Promise<{ isSuccess: boolean }>;
  showPreconfiguredMessages: boolean;
  gpxFeature?: GPXFeature;
}

const TF911StartChatAccordion = ({
  isCreatingConversation,
  isForOverview = false,
  isUniteEventPaneEnabled,
  onClickShowAccordion,
  onStartConversation,
  showPreconfiguredMessages,
  gpxFeature = GPX_FEATURES.TF911,
}: TF911StartChatAccordionProps) => {
  const preconfiguredMessages = usePreconfiguredMessages();

  const isVT911Enabled = useIsVT911Enabled();

  const handleDefaultStartClick = () => {
    onStartConversation();
    trackStartTF911Click({
      feature: gpxFeature,
      fromOverviewTab: isForOverview,
      isUniteEventPaneEnabled,
    });
  };

  const handleOnClickShowAccordion = () => {
    onClickShowAccordion();
    trackTogglingTF911Accordion({
      isExpanded: !showPreconfiguredMessages,
      feature: gpxFeature,
      fromOverviewTab: isForOverview,
      isUniteEventPaneEnabled,
    });
  };

  if (isUniteEventPaneEnabled) {
    return (
      <TF911StartChatNoAccordion
        handleDefaultStartClick={handleDefaultStartClick}
        isCreatingConversation={isCreatingConversation}
        isForOverview={isForOverview}
        isVT911Enabled={isVT911Enabled}
        onStartConversation={onStartConversation}
      />
    );
  }

  return (
    <TF911StartChatBase
      gpxFeature={gpxFeature}
      handleDefaultStartClick={handleDefaultStartClick}
      handleOnClickShowAccordion={handleOnClickShowAccordion}
      isCreatingConversation={isCreatingConversation}
      isForOverview={isForOverview}
      onStartConversation={onStartConversation}
      preconfiguredMessages={preconfiguredMessages}
      showPreconfiguredMessages={showPreconfiguredMessages}
    />
  );
};

export default TF911StartChatAccordion;
